
import { Vue, Component, Watch } from "vue-property-decorator";
import { configStore, documentStore, uiStore } from "@/store/store-accessor";
import { findNode } from "@/lib/tree/tree";

@Component({})
export default class GhostElement extends Vue {
  @Watch("draggedElement")
  onDragElementSet() {
    if (this.draggedElement) {
      this.scrollInterval = setInterval(this.startAutoScroll, 20);
    } else {
      this.stopAutoScroll();
    }
  }

  scrollInterval: NodeJS.Timeout | null = null;

  get dragPosition() {
    return uiStore.dragMousePosition;
  }

  get draggedElement() {
    const slug = uiStore.currentlyDraggingAddElementSlug;
    const id = uiStore.currentlyDraggingCanvasElementId;

    if (slug) return slug;

    if (id) {
      const maybeElement = this.draggedNode;

      if (maybeElement) {
        return maybeElement.data.type;
      }
    }

    return null;
  }

  get draggedNode() {
    if (!uiStore.currentlyDraggingCanvasElementId) {
      return null;
    }

    return findNode(
      documentStore.document.tree,
      uiStore.currentlyDraggingCanvasElementId
    );
  }

  get elementName() {
    if (!this.draggedElement) {
      return "";
    }

    const friendlyName = this.draggedNode?.data?.properties?.meta?.friendlyName;
    if (friendlyName) return friendlyName;

    const element = configStore.element(this.draggedElement);
    return element.name;
  }

  maxScrollSpeed = 30;
  edgeThreshold = 100;

  calculateScrollSpeed(distance: number) {
    return Math.max(
      0,
      this.maxScrollSpeed * (1 - distance / this.edgeThreshold)
    );
  }

  startAutoScroll() {
    if (!this.dragPosition) return;

    const doc = window.Breakdance.canvas.document;
    const win = doc.defaultView;

    // Disable smooth scrolling for auto-scrolling
    doc.documentElement.style.scrollBehavior = "auto";

    if (!win) return;

    const viewportHeight = win.innerHeight;
    const mouseY = this.dragPosition.y;

    // Determine scroll direction based on proximity to edges
    let scrollY = 0;

    if (mouseY < this.edgeThreshold) {
      scrollY = -this.calculateScrollSpeed(mouseY); // Scroll up
    } else if (mouseY > viewportHeight - this.edgeThreshold) {
      scrollY = this.calculateScrollSpeed(viewportHeight - mouseY); // Scroll down
    }

    if (scrollY !== 0) {
      win.scrollBy({
        top: scrollY,
        behavior: "auto"
      });
    }
  }

  stopAutoScroll() {
    const doc = window.Breakdance.canvas.document;
    doc.documentElement.style.scrollBehavior = "";

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }
}
